module.exports = __webpack_public_path__ + "static/img/strona_040.eb14c3ad.jpg";